import React, { useEffect } from 'react';

// Google AdSense Ad Component
// Replace 'ca-pub-XXXXXXXXXXXXXXXX' with your actual AdSense Publisher ID
const ADSENSE_CLIENT = 'ca-pub-XXXXXXXXXXXXXXXX'; // Your AdSense Publisher ID

// Ad unit component
export const AdBanner = ({ 
  slot, 
  format = 'auto', 
  responsive = true,
  style = {},
  className = ''
}) => {
  useEffect(() => {
    try {
      if (window.adsbygoogle) {
        window.adsbygoogle.push({});
      }
    } catch (err) {
      console.log('AdSense error:', err);
    }
  }, []);

  return (
    <div className={`ad-container ${className}`} style={{ textAlign: 'center', ...style }}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block', ...style }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive}
      />
    </div>
  );
};

// Horizontal banner ad (728x90 or responsive)
export const HorizontalAd = ({ slot = '1234567890', className = '' }) => (
  <div className={`my-4 ${className}`}>
    <AdBanner 
      slot={slot} 
      format="horizontal" 
      style={{ minHeight: '90px' }}
    />
  </div>
);

// In-article ad
export const InArticleAd = ({ slot = '2345678901', className = '' }) => (
  <div className={`my-6 ${className}`}>
    <AdBanner 
      slot={slot} 
      format="fluid" 
      style={{ minHeight: '250px' }}
    />
  </div>
);

// Sidebar ad (300x250 or responsive)
export const SidebarAd = ({ slot = '3456789012', className = '' }) => (
  <div className={`${className}`}>
    <AdBanner 
      slot={slot} 
      format="rectangle" 
      style={{ minHeight: '250px', maxWidth: '300px' }}
    />
  </div>
);

// Multiplex ad (related content style)
export const MultiplexAd = ({ slot = '4567890123', className = '' }) => (
  <div className={`my-6 ${className}`}>
    <AdBanner 
      slot={slot} 
      format="autorelaxed" 
      style={{ minHeight: '300px' }}
    />
  </div>
);

// Placeholder ad component (for development/before AdSense approval)
export const PlaceholderAd = ({ 
  width = '100%', 
  height = '90px', 
  label = 'Advertisement',
  className = ''
}) => (
  <div 
    className={`bg-slate-100 border border-slate-200 rounded-lg flex items-center justify-center ${className}`}
    style={{ width, height, minHeight: height }}
  >
    <div className="text-center">
      <p className="text-slate-400 text-xs uppercase tracking-wide">{label}</p>
    </div>
  </div>
);

export default AdBanner;
